import {
  AcademicCapIcon,
  BuildingOfficeIcon,
  UserIcon,
  WrenchScrewdriverIcon
} from '@heroicons/react/24/outline'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/tailwind/Button'
import { Heading } from '../../../../components/ui/Heading'

export default function CategorySelectionMessage({
  availableDimensions = [],
  onDimensionSelect,
  className,
  categories
}) {
  const { t } = useTranslation()

  console.log({ availableDimensions, onDimensionSelect, className })

  const dimensionIcons = {
    [categories.skills]: AcademicCapIcon,
    [categories.culture]: BuildingOfficeIcon,
    [categories.personality]: UserIcon,
    [categories.interests]: WrenchScrewdriverIcon
  }

  const handleDimensionClick = (dimension) => {
    if (onDimensionSelect) {
      onDimensionSelect(dimension)
    }
  }

  return (
    <div
      className={clsx(
        'w-full max-w-md space-y-3 rounded-lg border border-lightGrey bg-[#F7F9FE] p-4',
        className
      )}
    >
      <div>
        <Heading level={5}>
          {t('discover.assistant.chances_and_risks.second_message.title')}
        </Heading>
        <p className='mt-2 text-sm text-darkBlack'>
          {t('discover.assistant.chances_and_risks.second_message.description')}
        </p>
      </div>

      <div className='grid grid-cols-2 gap-2'>
        {availableDimensions.map((dimension) => {
          const Icon = dimensionIcons[dimension]
          return (
            <Button.SecondaryBase
              key={dimension}
              text={
                <div className='flex flex-col items-center gap-1 py-2'>
                  <Icon className='h-5 w-5 text-primaryBlue' />
                  <span className='text-xs font-medium'>{dimension}</span>
                </div>
              }
              onClick={() => handleDimensionClick(dimension)}
              className='h-auto min-h-[80px] flex-col transition-all duration-200 hover:border-primaryBlue hover:bg-paleWhiteBlue'
            />
          )
        })}
      </div>
    </div>
  )
}

CategorySelectionMessage.propTypes = {
  availableDimensions: PropTypes.arrayOf(PropTypes.string),
  onDimensionSelect: PropTypes.func,
  className: PropTypes.string
}
